<template>
	<div class="channelCell">
		<div class="header flex flex-just-between flex-align-center mb-10">
			<div class="flex flex-align-center">
				<el-tooltip :content="row.activity_name" placement="top">
					<p class="activity-name ellipsis yx-color-text-primary fz-16">{{ row.activity_name }}</p>
				</el-tooltip>
				<p class="recommend" v-if="row.is_top">超盘手推荐</p>
			</div>
			<p class="yx-color-text-regular"
				><span>{{ row.apply_end_time }}</span
				><span class="ml-6 mr-30">截止</span></p
			>
		</div>
		<div class="body flex flex-just-between">
			<div class="left fz-13">
				<div class="flex">
					<p class="yx-color-text-regular nowrap">活动要求:</p>
					<el-tooltip placement="top">
						<div slot="content" class="activity-desc-tooltip">
							{{ row.activity_desc }}
						</div>
						<p class="yx-color-text-primary ml-10 activity-desc">{{ row.activity_desc }}</p>
					</el-tooltip>
				</div>
			</div>
			<div class="middle nowrap flex">
				<div class="item">
					<p class="yx-color-text-primary">{{ row.commission_rate }}%</p>
					<p class="yx-color-text-regular fz-12">最低佣金</p>
				</div>
				<div class="item">
					<p class="yx-color-text-primary">{{ row.service_rate }}%</p>
					<p class="yx-color-text-regular fz-12">服务费</p>
				</div>
				<div class="item">
					<p class="yx-color-text-primary"
						>每单品<span class="ml-4 mr-4">{{ row.estimated_single_sale }}</span></p
					>
					<p class="yx-color-text-regular fz-12">预估平均成绩销售额(元)</p>
				</div>
			</div>
			<div class="middle nowrap flex">
				<div class="item">
					<p class="yx-color-text-primary">{{ row.apply_num }}款</p>
					<p class="yx-color-text-regular fz-12">已报名商品</p>
				</div>
				<div class="item">
					<p class="yx-color-text-primary">{{ row.audit_pass_num }}款</p>
					<p class="yx-color-text-regular fz-12">已通过</p>
				</div>
			</div>
			<div class="right flex flex-align-center flex-just-center" v-if="$auth.hasPermi('system:colonelActivitySquare:Registered')">
				<el-button
					v-if="tabName === '0'"
					:class="[todayCheck(row.apply_end_time) ? 'default' : '']"
					:disabled="todayCheck(row.apply_end_time)"
					@click="signUp"
					>立即报名</el-button
				>
				<div v-if="tabName === '1'" class="align-center">
					<el-button @click="goOn" :class="[todayCheck(row.apply_end_time) ? 'default' : '']" :disabled="todayCheck(row.apply_end_time)"
						>继续报名</el-button
					>
				</div>
			</div>
		</div>
		<div class="bottom flex flex-align-center">
			<div class="flex flex-align-center">
				<img src="@/assets/public/home-icon.png" alt="" />
				<p class="yx-color-text-regular fz-14 ml-6">{{ row.institution_name }}</p>
			</div>
			<div class="ml-20 fz-13 yx-color-text-primary" v-if="tabName === '1'">
				<span>手机号：</span><span>{{ row.phone_num }}</span>
			</div>
			<div class="ml-20 fz-13 yx-color-text-primary" v-if="tabName === '1'">
				<span>微信号：</span><span>{{ row.wechat_id }}</span>
			</div>
		</div>
	</div>
</template>
<script>
import { todayCheck } from '@/utils/validate';
import { mapGetters } from 'vuex';
export default {
	name: 'channelCell',
	data() {
		return {
			todayCheck: todayCheck,
		};
	},
	methods: {
		signUp() {
			const { row } = this;
			let handLink = this.$router.resolve({
				path: '/secondColonelManage/colonelActivitySquare/detail',
				query: {
					id: row.activity_id,
					third_activity_id: row.third_activity_id,
					signUp: '0',
				},
			});
			window.open(handLink.href, '_blank');
		},
		goOn() {
			const { row } = this;
			let handLink = this.$router.resolve({
				path: '/secondColonelManage/colonelActivitySquare/detail',
				query: {
					id: row.activity_id,
					third_activity_id: row.third_activity_id,
					signUp: '1',
				},
			});
			window.open(handLink.href, '_blank');
		},
	},
};
</script>
<style lang="less" scoped>
.Bubble {
	background-color: #f6f5fc;
	border: 1px solid @color-primary;
	border-radius: 2px;
	font-weight: 400;
	padding: 0px 6px;
}

.left {
	width: 400px;
}

.right {
	width: 200px;
	padding-left: 40px;
	border-left: 1px solid #eeeeee;

	/deep/ .el-button {
		color: @color-primary !important;
	}

	/deep/ .default {
		color: #cccccc !important;
	}
}

.middle {
	padding-left: 40px;
	border-left: 1px solid #eeeeee;
}

.item {
	margin-left: 30px;
	font-family: PingFangSC-Regular, PingFang SC;
	text-align: left;
}

.bottom {
	margin-top: 10px;
	padding-top: 10px;
	border-top: 1px solid #eeeeee;
}

.bottom img {
	width: 20px;
	height: 20px;
}

.recommend {
	margin-left: 10px;
	font-size: 12px;
	padding: 0px 8px;
	border-radius: 4px;
	height: 18px;
	line-height: 18px;
	color: #fff;
	background-color: @color-primary;
}

.look:hover {
	cursor: pointer;
	color: @color-primary;
}

.activity-desc-tooltip {
	max-width: 300px;
}

.activity-desc {
	text-overflow: -o-ellipsis-lastline;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	-webkit-box-orient: vertical;
}

.activity-name {
	display: inline-block;
	max-width: 400px;
	font-family: PingFangSC-Medium, PingFang SC;
}

@media screen and (max-width: 1400px) {
	.middle {
		padding-left: 0px;
	}
}
</style>
